var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorBannerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8C15.75 12.2812 12.25 15.75 8 15.75C3.71875 15.75 0.25 12.2812 0.25 8C0.25 3.75 3.71875 0.25 8 0.25C12.25 0.25 15.75 3.75 15.75 8ZM8 9.5625C7.1875 9.5625 6.5625 10.2188 6.5625 11C6.5625 11.8125 7.1875 12.4375 8 12.4375C8.78125 12.4375 9.4375 11.8125 9.4375 11C9.4375 10.2188 8.78125 9.5625 8 9.5625ZM6.625 4.40625L6.84375 8.65625C6.875 8.875 7.03125 9 7.21875 9H8.75C8.9375 9 9.09375 8.875 9.125 8.65625L9.34375 4.40625C9.375 4.1875 9.1875 4 8.96875 4H7C6.78125 4 6.59375 4.1875 6.625 4.40625Z",
    fill: "#B30303"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorBannerIcon);
export default __webpack_public_path__ + "static/media/error-banner-icon.bdb370bd5aa945972bb9b86cf65281ff.svg";
export { ForwardRef as ReactComponent };